import { Component, OnInit } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-bool-cell',
  templateUrl: './bool-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class BoolCellComponent extends InlineEditCellDirective implements OnInit {
  ngOnInit(): void {}

  triggerEdit() {
    setTimeout(() => {
      this.originalContent = this.rowData[this.fieldName]
      this.isEdited = true
    }, 0)
  }
}
